import { useContentful } from "frontend/hooks/use-contentful";
import { usePageProps } from "frontend/hooks/use-page-props";

export function homeHiddenTitle(title: string): string | undefined {
  const { request } = usePageProps();
  const { site } = useContentful();

  return site?.fields.title &&
    title.trim() !== site.fields.title.trim() &&
    (request.path.substring(1) === site?.fields.slug ||
      (request.path === "/" && site?.fields.domain !== "www"))
    ? site?.fields.title
    : undefined;
}
